import moment from 'moment';

declare global {
    interface Date {
        toDateOnly(): string;
    }
}

if (!Date.prototype.toDateOnly) {
    Date.prototype.toDateOnly = function (): string {
        return (this as Date) ? moment(this as Date).format('YYYY-MM-DD') : null;
    };
}

export {};
